import { NgModule } from '@angular/core';
import { AnaBizContextStoreService } from './ana-biz-context-store.service';

@NgModule({
  providers: [AnaBizContextStoreService],
})
export class AnaBizContextStoreServiceModule {}
